import "../../assets/LabelText.css";
import { jsx as s } from "react/jsx-runtime";
const a = "_label_1u8nk_3", t = {
  label: a
}, n = ({
  children: l,
  ...e
}) => /* @__PURE__ */ s("span", { ...e, className: t.label, children: l });
export {
  n as LabelText
};
